import React from 'react'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import { Typography, Grid } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: 'rgba(248, 249, 252, 1)',
  },
}))
type EmptyTableRowProps = {
  cellCount: number
}
const EmptyTableRow = ({ cellCount }: EmptyTableRowProps) => {
  return (
    <StyledTableRow hover role='checkbox' tabIndex={-1}>
      <TableCell
        align='center'
        sx={{
          border: 'none',
        }}
        colSpan={cellCount}
      >
        <Grid container justifyContent='center'>
          <Typography variant='subtitle1' textAlign='center'>
            No Result Found
          </Typography>
        </Grid>
      </TableCell>
    </StyledTableRow>
  )
}

export default EmptyTableRow
